import angular from 'angular'
import moment from 'moment-timezone'

angular.module('admin.product.edit', []).controller('ProductEditCtrl', ProductEditCtrl)

/** @ngInject */
function ProductEditCtrl(
  $scope,
  $state,
  $q,
  $timeout,
  $stateParams,
  CoinProductService,
  UserSegmentationService,
  UploadService,
  CsvService,
  TranslatorService,
) {
  var vm = this
  vm.model = {}
  vm.pathImgH = ''
  vm.id = $stateParams.id
  vm.type = $stateParams.type || 'cash'
  vm.loadH = false
  vm.cohorts = [
    {
      id: 0,
      name: 'A: Non-payers',
    },
    {
      id: 1,
      name: 'B: Purchased $1 product > 7 days ago',
    },
    {
      id: 2,
      name: 'C: Purchased $2 product > 7 days ago',
    },
    {
      id: 3,
      name: 'D: Purchased $5 product > 7 days ago',
    },
    {
      id: 4,
      name: 'E: Purchased $10 product > 7 days ago',
    },
    {
      id: 5,
      name: 'F: Purchased $20 product > 7 days ago',
    },
    {
      id: 6,
      name: 'G: Purchased $50 product > 7 days ago',
    },
    {
      id: 7,
      name: 'H: Purchased in last 24 hours',
    },
    {
      id: 8,
      name: 'I: Purchased in last 7 days',
    },
  ]

  vm.types = [
    {
      id: 1,
      name: 'Coins',
    },
    {
      id: 2,
      name: 'Direct Purchase',
    },
    {
      id: 4,
      name: 'Cash',
    },
    {
      id: 5,
      name: 'Game Token',
    },
  ]

  vm.priorities = [
    {
      id: 0,
      name: 'Default',
    },
    {
      id: 1,
      name: 'Default Replacement',
    },
    {
      id: 2,
      name: 'Additional and/or Web',
    },
  ]

  vm.stores = [
    {
      id: 0,
      name: 'App Store',
    },
    {
      id: 3,
      name: 'Web Stripe',
    },
  ]

  vm.model.store = vm.stores[0].id

  vm.isOpen = false
  vm.isOpen2 = false
  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }
  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  if (vm.type === 'cash') {
    vm.model.k = vm.types[2].id
    vm.model.c = 0
  } else if (vm.type === 'dp') {
    vm.model.k = vm.types[1].id
    vm.model.c = 0
  } else if (vm.type === 'game_token') {
    vm.model.k = vm.types[3].id
    vm.model.c = 0
  } else {
    vm.model.k = vm.types[0].id
  }

  vm.segmentations = []
  vm.productSegmentations = []
  vm.productTranslations = []
  vm.title = null

  function loadTranslations() {
    CoinProductService.listTranslations($stateParams.id).then(function (result) {
      vm.productTranslations = result.results
    })
  }

  loadTranslations()

  if (vm.id !== '0') {
    CoinProductService.get($stateParams.id).then(function (result) {
      vm.model = result.results
      vm.title = vm.model.t
      if (vm.model['ts-p'] !== undefined && vm.model['ts-p'] !== 0) {
        vm.model['ts-p'] = vm.model['ts-p']
          .toString()
          .substring(0, vm.model['ts-p'].toString().length - 3)
        vm.model['ts-p'] = new Date(parseInt(vm.model['ts-p']))
        vm.data1 = angular.copy(vm.model['ts-p'])
      }
      if (vm.model['ts-x'] !== undefined && vm.model['ts-x'] !== 0) {
        vm.model['ts-x'] = vm.model['ts-x']
          .toString()
          .substring(0, vm.model['ts-x'].toString().length - 3)
        vm.model['ts-x'] = new Date(parseInt(vm.model['ts-x']))
        vm.data2 = angular.copy(vm.model['ts-x'])
      }
    })
  } else {
    vm.model.img = ''
  }

  CoinProductService.listProductSegmentation($stateParams.id).then(function (result) {
    vm.productSegmentations = generateType(result.results)
  })

  CoinProductService.listSegmentation().then(function (result) {
    vm.segmentations = _.filter(result.results, { arch: false })
  })

  // var makeTranslation = function (t, txt, currentTranslations, paramsId, route) {
  //   TranslatorService.translateProductAllLanguage(t, txt).then(function (res) {
  //     var languages = ['ja', 'ko', 'zh', 'zh-TW']

  //     for (var i = 0; i < currentTranslations.length; i++) {
  //       for (var key in res.t.results) {
  //         if (currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1) {
  //           languages.remove('ja')
  //         }
  //         if (currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1) {
  //           languages.remove('ko')
  //         }
  //         if (currentTranslations[i].comm === 'SC' && key.indexOf('zh') !== -1) {
  //           languages.remove('zh')
  //         }
  //         if (currentTranslations[i].comm === 'TC' && key.indexOf('zh-TW') !== -1) {
  //           languages.remove('zh-TW')
  //         }
  //       }
  //     }

  //     // if (vm.title && vm.title === t && languages.length === 0 && currentTranslations.length === 4) {
  //     //   $state.go(route, { parentId: vm.parentId });
  //     //   return
  //     // }

  //     if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //       var promises = []

  //       for (var i = 0; i < currentTranslations.length; i++) {
  //         // if (currentTranslations[i]['id-u']) {
  //         //   continue
  //         // }
  //         if (currentTranslations[i].comm === 'SC' && res.t.results) {
  //           var exist = _.find(languages, 'zh')
  //           if (exist) {
  //             promises.push(
  //               CoinProductService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'SC',
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               CoinProductService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'TC' && res.t.results) {
  //           var exist = _.find(languages, 'zh-TW')
  //           if (exist) {
  //             promises.push(
  //               CoinProductService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'TC',
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               CoinProductService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'KR' && res.t.results) {
  //           var exist = _.find(languages, 'ko')
  //           if (exist) {
  //             promises.push(
  //               CoinProductService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'KR',
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               CoinProductService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'JP' && res.t.results) {
  //           var exist = _.find(languages, 'ja')
  //           if (exist) {
  //             promises.push(
  //               CoinProductService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'JP',
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               CoinProductService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //       }

  //       $q.all(promises)
  //         .then(function () {
  //           $state.go(route, { parentId: vm.parentId })
  //         })
  //         .catch(function (err) {
  //           swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //         })
  //     }

  //     var promises = []

  //     for (var i = 0; i < languages.length; i++) {
  //       if (languages[i] === 'zh' && res.t.results) {
  //         promises.push(
  //           CoinProductService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'SC',
  //             t: res.t.results.zh,
  //             txt: res.txt.results.zh,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'zh-TW' && res.t.results) {
  //         promises.push(
  //           CoinProductService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'TC',
  //             t: res.t.results['zh-TW'],
  //             txt: res.txt.results['zh-TW'],
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ko' && res.t.results) {
  //         promises.push(
  //           CoinProductService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'KR',
  //             t: res.t.results.ko,
  //             txt: res.txt.results.ko,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ja' && res.t.results) {
  //         promises.push(
  //           CoinProductService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'JP',
  //             t: res.t.results.ja,
  //             txt: res.txt.results.ja,
  //           }),
  //         )
  //       }
  //     }

  //     $q.all(promises)
  //       .then(function () {
  //         $state.go(route, { parentId: vm.parentId })
  //       })
  //       .catch(function () {
  //         swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //       })
  //   })
  // }

  vm.save = function () {
    var model = angular.copy(vm.model)
    delete model.ts
    delete model['ts-p']
    delete model['ts-m']
    delete model['ts-x']
    if (model.t === undefined || model.t === '' || model.t === null) {
      swal('Required title field.', '', 'error')
      return
    }

    if (model.txt === undefined || model.txt === '' || model.txt === null) {
      swal('Required description field.', '', 'error')
      return
    }

    if (model.t.length > 255) {
      swal('Limit title 255 characters', '', 'warning')
      return
    }

    if (model.txt.length > 255) {
      swal('Limit description 255 characters', '', 'warning')
      return
    }

    var isDate = function (date) {
      return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
    }

    if (vm.data1) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-p'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-p'] = null
    }

    if (vm.data2) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-x'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-x'] = null
    }

    model.c = parseInt(model.c)
    model.price = parseFloat(model.price)
    model.gt = parseInt(model.gt)

    if (model.id !== undefined && model.id !== '' && model.id !== 0) {
      CoinProductService.update(model.id, model).then(
        function () {
          if (vm.type === 'cash') {
            // makeTranslation(model.t, model.txt, vm.productTranslations, model.id, 'admin.product')
            $state.go('admin.product')
          } else if (vm.type === 'dp') {
            // makeTranslation(model.t, model.txt, vm.productTranslations, model.id, 'admin.product')
            $state.go('admin.product')
          } else {
            // makeTranslation(model.t, model.txt, vm.productTranslations, model.id, 'admin.product')
            $state.go('admin.product')
          }
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 250)
        },
      )
    } else {
      CoinProductService.save(model).then(
        function (result) {
          if (vm.type === 'cash') {
            // makeTranslation(
            //   model.t,
            //   model.txt,
            //   vm.productTranslations,
            //   result.results.id,
            //   'admin.product',
            // )
            $state.go('admin.product')
          } else if (vm.type === 'dp') {
            // makeTranslation(
            //   model.t,
            //   model.txt,
            //   vm.productTranslations,
            //   result.results.id,
            //   'admin.product',
            // )
            $state.go('admin.product')
          } else {
            // makeTranslation(
            //   model.t,
            //   model.txt,
            //   vm.productTranslations,
            //   result.results.id,
            //   'admin.product',
            // )
            $state.go('admin.product')
          }
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 250)
        },
      )
    }
  }

  vm.cancel = function () {
    $state.go('admin.product')
  }

  vm.uploadH = function (item) {
    vm.loadH = true
    UploadService.save('coins', vm.pathImgH, 'img', item.id).then(function (fileName) {
      vm.loadH = false
      item.img = fileName
    })
  }

  vm.addSegmentation = function () {
    CoinProductService.addProductSegmentation($stateParams.id, vm.segmentationId).then(
      function () {
        CoinProductService.listProductSegmentation($stateParams.id).then(function (result) {
          vm.productSegmentations = generateType(result.results)
        })
      },
      function () {
        swal('This user segmentation already exists', '', 'error')
      },
    )
  }

  vm.deleteSegmentation = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: 'You really want to delete?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          CoinProductService.removeProductSegmentation($stateParams.id, id).then(function () {
            CoinProductService.listProductSegmentation($stateParams.id).then(function (result) {
              vm.productSegmentations = generateType(result.results)
            })
          })
        } else {
          return
        }
      },
    )
  }

  vm.exportCsv = function () {
    CsvService.validSafari()

    var promise = {}

    var listCsv = []
    for (var i = 0; i < vm.productSegmentations.length; i++) {
      promise[vm.productSegmentations[i].id] =
        UserSegmentationService.listUserBySegmentationWithoutPagination(
          vm.productSegmentations[i].id,
        )
    }

    $q.all(promise).then(function (result) {
      var listUsers = []
      for (var x = 0; x < vm.productSegmentations.length; x++) {
        var users = result[vm.productSegmentations[x].id].results
        users.map(function (item) {
          listUsers.push(item)
        })
      }
      listUsers = _.uniqBy(listUsers, 'id')
      for (var j = 0; j < listUsers.length; j++) {
        listCsv.push({
          id: listUsers[j].id,
          username: listUsers[j].username === undefined ? '' : listUsers[j].username,
          email: listUsers[j].email,
          name: listUsers[j].name === undefined ? '' : listUsers[j].name,
        })
      }

      var csv = CsvService.convertArrayOfObjectsToCSV({
        data: listCsv,
      })

      if (csv === null) {
        return
      }

      if (CsvService.isSafari() || CsvService.isFirefox()) {
        var link = document.createElement('a')
        link.id = 'csvDwnLink'

        document.body.appendChild(link)
        window.URL = window.URL || window.webkitURL
        var csv2 = '\ufeff' + csv,
          csvData = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csv2),
          filename = vm.model.t + '.csv'
        $('#csvDwnLink').attr({ download: filename, href: csvData })
        $('#csvDwnLink')[0].click()
        document.body.removeChild(link)
      } else {
        var filename = vm.model.t + '.csv'

        if (!csv.match(/^data:text\/csv/i)) {
          csv = 'data:text/csv;charset=utf-8,' + csv
        }

        var data = encodeURI(csv)
        var link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', filename)
        link.click()
      }
    })
  }

  vm.changeCoinType = function () {
    if (vm.model.k === 2 || vm.model.k === 4) {
      vm.model.c = 0
    }
  }

  function generateType(model) {
    for (var i = 0; i < model.length; i++) {
      if (model[i].k === 1) {
        model[i].type = 'Product'
      } else if (model[i].k === 2) {
        model[i].type = 'Bundle'
      } else if (model[i].k === 3) {
        model[i].type = 'Set'
      }
    }
    return model
  }

  vm.pathImgTranslation = ''
  vm.loadTranslation = false
  vm.translate = {}
  vm.addTranslate = function () {
    vm.translate = {}
    $('#modalTranslate').modal('show')
  }

  vm.classDisabled = function () {
    if (!vm.translate.comm || !vm.translate.t || !vm.translate['txt']) {
      return 'is-disabled'
    } else {
      return
    }
  }

  vm.saveTranslate = function () {
    if (vm.translate.id) {
      CoinProductService.updateTranslation(vm.translate.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslate').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      CoinProductService.saveTranslation($stateParams.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslate').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.editTranslate = function (id) {
    CoinProductService.getTranslation(id).then(
      function (result) {
        vm.translate = result.results
        $('#modalTranslate').modal('show')
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteTranslate = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          CoinProductService.removeTranslation(id).then(
            function () {
              loadTranslations()
              vm.translate = {}
              $('#modalTranslate').modal('hide')
            },
            function (err) {
              $timeout(function () {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.uploadTranslation = function (item) {
    vm.loadTranslation = true
    UploadService.save('coins', vm.pathImgTranslation, 'img', item.id).then(function (fileName) {
      vm.loadTranslation = false
      item.img = fileName
    })
  }

  var watch1 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch2 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
  })
}
